export const CREDIT_DEDUCTION_REASON_OPTIONS = [
  {
    value: 0,
    label: 'Credits debited due to course pause request.',
    tag: 'credit_deduction',
  },
  {
    value: 1,
    label: 'Credits debited due to disenrollment from degree.',
    tag: 'degree_disenrollment',
  },
  {
    value: 2,
    label: 'Other Reason',
    tag: 'other',
  },
];
